import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PreferencesService } from '../../../preferences.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-alert-percentage-settings-popup',
  templateUrl: './alert-percentage-settings-popup.component.html',
  styleUrls: ['./alert-percentage-settings-popup.component.scss']
})
export class AlertPercentageSettingsPopupComponent implements OnInit {
  settings: any = {
    75: false,
    80: false,
    85: false,
    90: false
  };
  selectedPercentage: number | null = null;
  AlertId: number;

  constructor(public dialogRef: MatDialogRef<AlertPercentageSettingsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private readonly _pref: PreferencesService, private readonly _notify: NotificationsService,) { }

  ngOnInit(): void {

    if (this.data.wornPercentage) {
      this.selectedPercentage = this.data.wornPercentage;
    }else{
      this.selectedPercentage = 75;
    }
  }
  close() {
    this.dialogRef.close();
  }

  selectPercentage(value: number) {
    this.selectedPercentage = value;
  }
  save() {
    const payload = {
      alertId: this.data.alertId,
      wornPercentage: this.selectedPercentage
    };
    this._pref.updateWornPercentage(payload)
      .subscribe(res => {
        if (res==1) {
          this._notify.success('Success', 'Updated Successfully');
          this.dialogRef.close(true);

        }
      });
  }
}
